export default __webpack_public_path__ + "static/elastic-079b85dc11790f102f50390d9072b506.png";